import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import FormField from "./FormField";

export default function Tools(){
    const menuDispatch = useDispatch();
    useEffect(() => {
        // menuDispatch({
        //     type: 'menuSelect',
        //     payload: 'user'
        // });
    }
    , []);
    return (
        // <UserList />
        <FormField/>
    )
}